var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoggedIn)?_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('h2',[_vm._v(_vm._s(_vm.$t('You are now logged out. To login again click'))+" "),_c('a',{attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.$t('here')))]),_vm._v(".")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }